export const CHANGE_AUTH_FLAG = "CHANGE_AUTH_FLAG";
export const AUTH_LOGOUT = "AUTH_LOGOUT";
export const GET_PROFILE = "GET_PROFILE";

export default {
  CHANGE_AUTH_FLAG,
  AUTH_LOGOUT,
  GET_PROFILE
};
